import React, { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getPrivacyPolicy } from "../../reduxStore/action/configurationSettingAction";
import { handleDetailResponse, seo } from "../../utils/utils";

const PrivacyPolicy = () => {
  const dispatch = useDispatch();
  const [privacyData, setPrivacyData] = useState({});

  const PrivacyPolicySelector = useSelector(
    (state) => state.configurationSettingDetail
  );

  useEffect(() => {
    if (PrivacyPolicySelector?.result) {
      setPrivacyData(handleDetailResponse(PrivacyPolicySelector?.result?.data));
    }
  }, []);

  useEffect(() => {
    dispatch(getPrivacyPolicy());
  }, [dispatch]);

  useEffect(() => {
    seo({
      title: "Privacy Policy",
      metaDescription: "Privacy policy",
      canonicalLink: window.location.href,
    });
  }, []);

  return (
    <Fragment>
      <div className="page-body">
        <h3 className="mt-3 mb-2 ml-3">Privacy Policy</h3>
        <div
          className="container-fluid"
          dangerouslySetInnerHTML={{ __html: privacyData?.text }}
        />
      </div>
    </Fragment>
  );
};

export default PrivacyPolicy;
